import React from "react";
import {
  searchStore,
  SearchTabsProps,
} from "features/ProductSearch/SearchStore";

const useProductSearch = (tabList: SearchTabsProps[]) => {
  const [loading, setLoading] = React.useState<boolean>(true);

  function setDefaultTab(shouldShowUsedProducts: boolean) {
    if (searchStore.selectedTab === undefined) {
      const defaultTab = shouldShowUsedProducts
        ? "used_products"
        : "custom_products";
      searchStore.setSelectedTab(tabList.find((t) => t.id === defaultTab));
    }
  }

  function handleTabSwitch() {
    if (
      searchStore.selectedTab?.id === "used_products" &&
      !searchStore.hasAnyUsedProducts
    ) {
      searchStore.setSelectedTab(
        tabList.find((t) => t.id === "custom_products")
      );
      searchStore.setIsUsedSearch(false);
    }
  }

  const initialCheck = async (isUsedSearchEnabled: boolean) => {
    await searchStore.checkUsedProductsStatus();
    const shouldShowUsedProducts =
      searchStore.hasAnyUsedProducts && isUsedSearchEnabled;

    if (searchStore.isUsedSearch === undefined) {
      searchStore.setIsUsedSearch(shouldShowUsedProducts);
    }

    setDefaultTab(shouldShowUsedProducts);
    handleTabSwitch();
  };

  return {
    initialCheck,
    loading,
    setLoading,
  };
};

export default useProductSearch;
